module.exports = __webpack_public_path__ + "img/additional-angle.33f5afb5.svg";